import { SocialLoginErrorCodeEnum } from '.';

export class SocialLoginError extends Error {
	code: SocialLoginErrorCodeEnum;
	title?: string;
	description?: string;
	cause?: unknown;

	constructor(
		code: SocialLoginErrorCodeEnum,
		options?: {
			title?: string;
			description?: string;
			cause?: unknown;
		}
	) {
		super(code);
		this.name = 'SocialLoginError';
		this.code = code;
		this.title = options?.title;
		this.description = options?.description;
		this.cause = options?.cause;
	}
}
